const list = () => import('./list');
const info = () => import('./info');
const edit = () => import('./edit');

const actionGroupRouter = [
  {
    path: '/actionGroup/list', name: 'actionGroupDataList', component: list, meta: { c: 'actionGroup', a: 'list' }
  },
  {
    path: '/actionGroup/info/:id', name: 'actionGroupInfo', component: info, meta: { c: 'actionGroup', a: 'info' }
  },
  {
    path: '/actionGroup/edit/:id', name: 'actionGroupEdit', component: edit, meta: { c: 'actionGroup', a: 'edit' }
  }
];

export default actionGroupRouter;
